// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2NjKs","modalFooterButton":"ModalNotes_modalFooterButton__3Vdee"};